import React from 'react';

let selectionSortContent = {
                            'videos': {
                                 'intuition': 'https://youtube.com/embed/p-v2fmaXiFI',
                                 'analysis': 'https://www.youtube.com/embed/OB6uxIG-C5w',
                                 'songAndCode': 'https://youtube.com/embed/iQD9qx4yGKw',
                             },
                            'img': (
                                <img src={'./sortedListThick2.png'} style={{"width": "460px", "maxWidth": "100%"}} />
                            ),
                            'intuition': ( 
                                <div style={{'paddingLeft':'10%','paddingRight':'10%',}}>
                                      <p>Selection sort finds the smallest value in the list and then swaps it with the value at position 0. It then looks from position 1 onwards for the second smallest value (the smallest is at position 0) and swaps that one with the one at position 1, does this for all remaining positions in the list.</p>
                                </div>
                            ),

                            'analysis': (
                                    <ul>
                                        <li>Learn the basics of big-O notation</li>
                                        <li>Determine why selection sort uses <i>O(n<sup>2</sup>)</i> or quadratic time in any case</li>
                                        <li>Determine why selection sort uses <i>O(1) </i> or constant extra memory in any case, i.e. it works in-place.</li>
                                        <li>Briefly discuss applications.</li>
                                    </ul>
                            ),

                            'songAndCode': (
                                    <ul>
                                        <li>Hear the 17-line, 90 second selection sort song:
                                            <ol>
                                                <li>The first part covers big-O analysis facts.</li>
                                                <li>The second covers the pseudocode which will help you program selection sort in any programming language.</li>
                                            </ol>
                                        </li>
                                        <li>Watch me demonstrate how to use the song lyrics to implement the algorithm in Python, the most straightforward programming language (in my opinion).</li>
                                    </ul>     
                            ),
}

export default selectionSortContent



// WEBPACK FOOTER //
// ./src/AlgoPageContent/selection-sort/content.jsx